<!-- Ícone de notificação e badge -->
<div class="notification-container" (click)="toggleNotifications(); $event.stopPropagation()">
  <patron-icon name="bi-bell" class="notification-icon"></patron-icon>
  @if (notifications.length > 0) {
    <span class="notification-badge">{{ notifications.length }}</span>
  }
</div>

<!-- Dropdown de notificações -->
@if (showNotifications) {
  <div
    class="notifications-dropdown surface-overlay border-1 surface-border shadow-2"
    (click)="$event.stopPropagation()">
    <div class="dropdown-header border-bottom-1 surface-border">
      <div class="header-content">
        <h6 class="mb-0 text-color">Notificações</h6>
        <div class="sound-toggle">
          <patron-icon
            [name]="soundEnabled ? 'bi-volume-up' : 'bi-volume-mute'"
            class="sound-icon clickable"
            [class.muted]="!soundEnabled"
            (click)="toggleSound()"></patron-icon>
          <label class="switch">
            <input type="checkbox" [checked]="soundEnabled" (change)="toggleSound()" />
            <span class="slider"></span>
          </label>
        </div>
      </div>
      <button
        type="button"
        class="btn-close"
        (click)="closeNotifications()"
        aria-label="Close"></button>
    </div>
    <div class="notifications-list">
      @if (notifications.length > 1) {
        <div
          class="clear-all-item border-bottom-1 surface-border"
          (click)="clearAllNotifications(); $event.stopPropagation()">
          <div class="clear-all-content">
            <patron-icon name="bi-trash" class="clear-all-icon"></patron-icon>
            <span class="clear-all-text">Limpar notificações</span>
          </div>
        </div>
      }
      @for (notification of notifications; track trackByNotificationId($index, notification)) {
        <div
          class="notification-item border-bottom-1 surface-border"
          (click)="openInTicketNewTab(notification)">
          <div class="notification-content">
            <div class="notification-header">
              <div class="notification-ref-container">
                <span class="notification-ref" [title]="notification.ref">{{
                  displayRef(notification.ref)
                }}</span>
                @if (notification.icon) {
                  <patron-icon
                    [class]="notification.iconColor || 'text-primary'"
                    [name]="notification.icon"
                    size="sm"
                    [patron-tooltip]="notification.iconTooltip || 'Notificação'">
                  </patron-icon>
                }
                <button
                  type="button"
                  class="btn-mute"
                  [class.muted]="isMuted(notification.ref)"
                  (click)="toggleMuteNotification(notification.ref); $event.stopPropagation()"
                  [title]="isMuted(notification.ref) ? 'Dessilenciar' : 'Silenciar'">
                  <patron-icon
                    [name]="
                      isMuted(notification.ref) ? 'bi-volume-mute-fill' : 'bi-volume-up-fill'
                    "></patron-icon>
                </button>
              </div>
              <span class="notification-time text-color-secondary">{{
                notification.dateTime | date: 'dd/MM/yyyy HH:mm'
              }}</span>
            </div>
            <div class="notification-title text-color font-semibold">{{ notification.title }}</div>
            <div class="notification-summary text-color-secondary">{{ notification.summary }}</div>
          </div>
          <div class="notification-actions">
            <button
              type="button"
              class="btn-delete"
              (click)="deleteNotification(notification.id); $event.stopPropagation()"
              title="Remover notificação">
              <patron-icon name="bi-x"></patron-icon>
            </button>
          </div>
        </div>
      }
      @if (notifications.length === 0) {
        <div class="no-notifications text-color-secondary">
          <patron-icon name="bi-bell-slash" class="no-notifications-icon opacity-50"></patron-icon>
          <p class="mb-0">Nenhuma notificação</p>
        </div>
      }
    </div>
  </div>
}
